import Splide from '@splidejs/splide';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

function carouselFull() {

    // console.log('Carousel Full block loaded');

    const carouselElements = document.querySelectorAll('[data-carousel-full]');

    carouselElements.forEach(carouselElement => {

        const navItems = carouselElement.closest('.carousel-full__container').querySelectorAll('.carousel-full__nav-item');
        const slides = carouselElement.querySelectorAll('.carousel-full__slide');

        let splitTexts = [];

        const getMoveDirection = (previousIndex, nextIndex, lastIndex) => {
            if (previousIndex === nextIndex) return 'forward';

            // Wrap al avanzar: ultimo -> primero.
            if (previousIndex === lastIndex && nextIndex === 0) return 'forward';

            // Wrap al retroceder: primero -> ultimo.
            if (previousIndex === 0 && nextIndex === lastIndex) return 'backward';

            return nextIndex > previousIndex ? 'forward' : 'backward';
        };

        // Función para animar un slide
        const animateSlide = (slideIndex, reset = true, direction = 'forward') => {
            const slide = slides[slideIndex];
            if (!slide) return;

            const image = slide.querySelector('.carousel-full__image-wrapper img');
            const title = slide.querySelector('.carousel-full__slide-title');
            const body = slide.querySelector('.carousel-full__slide-body');
            const split = splitTexts[slideIndex];

            // Timeline para la animación
            const tl = gsap.timeline();

            // Reset de elementos solo si se indica
            if (reset) {
                if (image) {
                    gsap.set(image, { x: direction === 'forward' ? '100%' : '-100%' });
                }
                if (title && split) {
                    gsap.set(split.words, { y: '100%' });
                }
                if (body) {
                    gsap.set(body, { opacity: 0 });
                }
            }

            // Animaciones
            if (image) {
                tl.to(image, {
                    x: '0%',
                    duration: 0.6,
                    ease: 'power3.out'
                }, 0);
            }

            if (title && split) {
                tl.to(split.words, {
                    y: '-3%',
                    duration: 0.4,
                    stagger: 0.04,
                    ease: 'power3.out'
                }, 0.2);
            }

            if (body) {
                tl.to(body, {
                    opacity: 1,
                    duration: 0.4,
                    ease: 'power2.out'
                }, 0.4);
            }
        };

        const splide = new Splide(carouselElement, {
            type: 'fade',
            // In fade mode, rewind simulates loop behavior at both edges.
            rewind: true,
            rewindByDrag: true,
            autoplay: false,
            speed: 800,
            arrows: true,
            pagination: false,
            height: '100%',
        });

        // Actualizar navegación cuando cambia el slide
        splide.on('move', (newIndex) => {
            navItems.forEach((item, index) => {
                if (index === newIndex) {
                    item.classList.add('is-active');
                } else {
                    item.classList.remove('is-active');
                }
            });
        });

        // Animar cuando se mueve a un nuevo slide
        splide.on('moved', (newIndex, prevIndex) => {
            const lastIndex = splide.length - 1;
            const direction = getMoveDirection(prevIndex, newIndex, lastIndex);

            animateSlide(newIndex, true, direction);
        });

        // Click en navegación
        navItems.forEach((navItem, index) => {
            navItem.addEventListener('click', () => {
                splide.go(index);
            });
        });

        splide.mount();

        // Preparar SplitText DESPUÉS de montar Splide para tener las dimensiones correctas
        slides.forEach(slide => {
            const titleContainer = slide.querySelector('.carousel-full__slide-title');
            if (titleContainer) {
                // Buscar el elemento de texto real (h1, h2, h3, h4, p)
                const titleElement = titleContainer.querySelector('h1, h2, h3, h4, p') || titleContainer;
                const split = new SplitText(titleElement, { type: 'words,lines', linesClass: 'split-line' });
                splitTexts.push(split);
            } else {
                splitTexts.push(null);
            }
        });

        // Reset inicial de todos los slides excepto el primero
        slides.forEach((slide, index) => {
            if (index === 0) return; // Saltar el primer slide

            const image = slide.querySelector('.carousel-full__image-wrapper img');
            const title = slide.querySelector('.carousel-full__slide-title');
            const body = slide.querySelector('.carousel-full__slide-body');
            const split = splitTexts[index];

            if (image) {
                gsap.set(image, { x: '100%' });
            }
            if (title && split) {
                gsap.set(split.words, { y: '100%' });
            }
            if (body) {
                gsap.set(body, { opacity: 0 });
            }
        });

        // Activar el primer item al inicio
        if (navItems.length > 0) {
            navItems[0].classList.add('is-active');
        }

        // Animar el primer slide al cargar (sin reset)
        setTimeout(() => {
            animateSlide(0, false, 'forward');
        }, 100);
    });
}

export default carouselFull;